import React from 'react';
import PropTypes from 'prop-types';
import MessageView from '../../../../Common/Components/MessageView.jsx';
import { upperCaseFirstLetter } from '../../../../Common/Utilities/StringUtilities';

class ValidationFailedView extends React.PureComponent
{
    render() {

        return <div data-component="ValidationFailedView">
            <div className="segment">
                <h2>{ `${upperCaseFirstLetter(this.props.nameOfObjectToImport)} import failed` }</h2>

                <p>The { this.props.nameOfObjectToImport } file <strong>{ this.props.fileName }</strong> failed to import successfully. Please correct the errors detailed below, then select the amended { this.props.nameOfObjectToImport } file above and try again.</p>

                <MessageView
                    title={ `${upperCaseFirstLetter(this.props.nameOfObjectToImport) } import validation failed` }
                    severity="failure"
                    icon="warning"
                    messages={ this.props.validationErrors }
                    closeable={ false } />
            </div>
        </div>
    }

    static propTypes = {
        validationErrors: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        fileName: PropTypes.string.isRequired,
        nameOfObjectToImport: PropTypes.string.isRequired,
    };
}

export default ValidationFailedView;
